// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1zjl3","active":"NavigationItem_active__2yxp1"};